import styled from 'styled-components';
import { SkeletonContainer } from 'ui/skeleton';
import { colors, heading4, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const PanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: ${colors.white};
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.half};
  padding: ${spacing.plusHalf};
`;

export const GreyPanelWrapper = styled.div<{ borderColor: string }>`
  background: ${colors.grey1};
  border-radius: ${spacing.half};
  border: ${spacing.single} solid ${({ borderColor }) => borderColor};
`;

export const PanelHeader = styled.div<{ padding: string }>`
  ${heading4}
  padding: ${({ padding }) => padding};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledSkeletonContainer = styled(SkeletonContainer)<{ height: number | string }>`
  display: flex;
  height: ${({ height }) => (typeof height === 'number' ? pxToRem(height) : height)};
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: ${spacing.half};
  border-bottom-left-radius: ${spacing.half};
  overflow: visible;
`;

export const PanelContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
